import { Container, Header, PieChart } from '@amzn/awsui-components-core';
import React from 'react';
import { EmptyStateMessage } from '../EmptyStateMessage';
import { PieChartDataSeries } from '../tickets/TicketsInterfaces';
import { FinTechOpsMessages } from '../FinTechOpsConstants';
import { i18nStringPieChart } from '../i18nStrings';
import { numberFormatter } from 'src/utilities/CommonUtilities';

type BusinessReportingPieChartProps = {
  data: PieChartDataSeries[];
  title: string;
  variant?: 'donut' | 'pie';
  isTimeSpentChart?: boolean;
};

export const BusinessReportingResolutionTypePieChart = ({
  data,
  title,
  variant = 'pie',
  isTimeSpentChart = false
}: BusinessReportingPieChartProps) => {
  // Calculate total time spent for donut chart center display
  const totalTimeSpent = data.reduce((sum, item) => sum + item.value, 0);

  const getSegmentDescription = (datum: { value: number }, sum: number) => {
    const percentage = sum === 0 ? '0' : ((datum.value / sum) * 100).toFixed(0);
    if (isTimeSpentChart) {
      return `${numberFormatter(datum.value.toFixed(2))} hrs (${percentage}%)`;
    }
    return `${numberFormatter(datum.value)} tickets (${percentage}%)`;
  };

  // Inner metric value for donut chart showing total time spent
  const getInnerMetricValue = () => {
    if (isTimeSpentChart && variant === 'donut') {
      return `${numberFormatter(Math.ceil(totalTimeSpent))} hrs`;
    }
    return undefined;
  };

  return (
    <Container fitHeight={true} header={<Header variant="h2">{title}</Header>}>
      <PieChart
        data={data}
        variant={variant}
        innerMetricValue={getInnerMetricValue()}
        segmentDescription={getSegmentDescription}
        i18nStrings={i18nStringPieChart()}
        ariaDescription={`Pie chart showing ${title.toLowerCase()}.`}
        ariaLabel="Pie chart"
        size="medium"
        errorText="Error loading data."
        loadingText="Loading Chart"
        hideFilter
        recoveryText="Retry"
        empty={<EmptyStateMessage title={FinTechOpsMessages.emptyStateMessage} subtitle={FinTechOpsMessages.emptyStateMessageDescription} />}
        noMatch={FinTechOpsMessages.noMatchMessage}
      />
    </Container>
  );
};
